import React from "react";
import Container from "./Container.jsx";

export default function AboutEthira() {
  return (
    <section id="about" className="py-16 sm:py-24 bg-white">
      <Container>
    
            <div className="mt-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#003366]">About Ethira</h2>
          <p className="mt-4 text-[#003366]">
            Ethira Property Group is an independent advisory focused on helping investors navigate the UK residential market.
            We combine data‑led research with on‑the‑ground insight to identify risk‑adjusted opportunities and structure
            acquisitions with clarity.
          </p>
        </div>
        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          <div className="rounded-2xl ring-1 ring-slate-200 p-6">
            <div className="text-3xl font-extrabold text-[#003366]">£500m+</div>
            <div className="mt-1 text-sm text-[#003366]">Transactions supported</div>
          </div>
          <div className="rounded-2xl ring-1 ring-slate-200 p-6">
            <div className="text-3xl font-extrabold text-[#003366]">15+ yrs</div>
            <div className="mt-1 text-sm text-[#003366]">Market experience</div>
          </div>
          <div className="rounded-2xl ring-1 ring-slate-200 p-6">
            <div className="text-3xl font-extrabold text-[#003366]">Nationwide</div>
            <div className="mt-1 text-sm text-[#003366]">City & regional coverage</div>
          </div>
          <div className="rounded-2xl ring-1 ring-slate-200 p-6">
            <div className="text-3xl font-extrabold text-[#003366]">Independent</div>
            <div className="mt-1 text-sm text-[#003366]">Research‑first approach</div>
          </div>

  
        </div>

       
      </Container>
    </section>
  );
}
 // <div className="mt-8">
        //  <a href="#/enquire" className="w-full sm:w-auto rounded-xl px-5 py-3 text-white font-semibold bg-[#003366] hover:bg-slate-800 text-center">
        //    Speak to our team →
        //  </a>
        // </div>